import axios from 'axios';
import { message } from 'antd';

let instance = axios.create();
// let retryRequest = [];
// let isRefresh = false;

const deepMerge = (sourceObject, targetObject) => {
    for(let key in targetObject) {
        if(!targetObject.hasOwnProperty(key)) continue;
        sourceObject[key] = sourceObject[key] && sourceObject[key].toString() === '[object Object]' ? deepMerge(sourceObject[key], targetObject[key]) : targetObject[key];
    }
    return sourceObject;
};

instance.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        // if (error && error.response && error.response.status === 401) {
        //     if (!isRefresh) {
        //         isRefresh = true;
        //         return fetchData('/sso/oauth/token', {
        //             headers: {
        //                 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        //                 Authorization: 'Basic ZXdlY2hhdDoxMjM0NTY='
        //             },
        //             data: `refresh_token=${localStorage.getItem('refresh_token')}&grant_type=refresh_token`
        //         }).then(res => {
        //             if (res && res.access_token) {
        //                 localStorage.setItem('access_token', res.access_token);
        //                 localStorage.setItem('expires_in', res.expires_in);
        //                 localStorage.setItem('refresh_token', res.refresh_token);
        //                 error.response.config.headers.Authorization = `Bearer ${res.access_token}`;
        //                 retryRequest.forEach(resolve => {
        //                     resolve(res.access_token);
        //                 });
        //                 retryRequest = [];
        //                 // isRefresh = false;
        //                 return instance(error.response.config);
        //             }
        //         })
        //             .finally(() => (isRefresh = false));
        //     } else {
        //         return new Promise(resolve => {
        //             retryRequest.push(access_token => {
        //                 error.response.config.headers.Authorization = `Bearer ${access_token}`;
        //                 resolve(instance(error.response.config));
        //             });
        //         });
        //     }
        // }
        // if (error && error.response && error.response.status === 400 && error.response.data && error.response.data.error === 'invalid_grant') {
        //     if (error.response.data.error_description.includes('Invalid refresh token')) {
        //         message.error('登录过期，请重新登录~');
        //     } else if (error.response.data.error_description.includes('Bad credentials')) {
        //         message.error('用户名或者密码错误~');
        //     } else {
        //         message.error(error.response.data.error_description);
        //     }
        // }
        // if (error && error.response && error.response.status === 409) {
        //     message.error('其他地方登录，请重新登录~');
        //     history.push('/');
        // }
        // if (error && error.response && error.response.status === 429) {
        //     message.error('系统繁忙，请稍后再试~');
        // }
        // if (error && error.response && error.response.status === 419) {
        //     message.error({ content: '用户账号已停用或已离职!', key: '419' });
        // }
    }
);

export function fetchData(url, params) {
    if (params && params.body) {
        params.data = params.body;
        delete params.body;

    }
    const headers = {
        'Content-Type': 'application/json',
        'cid': sessionStorage.companyId,
        'x-company-gray': sessionStorage.companyId
    };
    return instance(
        window.backendUrl + url,
        deepMerge({
            withCredentials: false,
            method: 'post',
            headers: headers
        }, params)
    );
}
